import * as CONS from '../../constants/urls'
import http from './httpService'

const API_ENDPOINT = `${CONS.API_ENDPOINT_EBM}/ProvinciaEBM`

export function buscarProvinciasEnEBM() {
  return http.get(`${API_ENDPOINT}/BuscarProvinciasEnEBM`)
}
